<template>
  <header class="px-3 py-1 w-full h-16 bg-white border-b border-slate-300 flex items-center justify-between">
    <slot />
    <div class="flex gap-2 items-center">
      <nav-plants />
      <select-locale />
      <button-user-avatar />
    </div>
  </header>
</template>
